import {ReactElement } from "react"
import { Navigate } from "react-router-dom"
import { SignIn } from "pages/SignIn";
import { OptimizationJobsProvider } from "contexts/OptimizationJobsContext";
import Layout from "components/Layout";
import { useAuth } from "contexts/AuthContext";
import { DRIVER_GROUP } from "constants/permissions";

interface Props {
  children: ReactElement
}

export const PrivatePage = ({ children }: Props): ReactElement => {
  const isAuthenticated = localStorage.getItem("bearerToken")
  const { userGroups } = useAuth()

  if (!isAuthenticated) {
    return <SignIn/>
  }

  // Contas do grupo Motorista não têm acesso ao painel administrativo -
  // a proteção real é o backend, isto é só defesa em profundidade na UI.
  if (userGroups.includes(DRIVER_GROUP)) {
    return <Navigate to="/motorista" replace/>
  }

  return (
    <OptimizationJobsProvider>
      <Layout>
        {children}
      </Layout>
    </OptimizationJobsProvider>
  )
}
